/* tslint:disable */
/* eslint-disable */
/**
 * Notification service API
 * Service for handling and managing notifications
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EmailForSendingDto,
} from '../models/index';
import {
    EmailForSendingDtoFromJSON,
    EmailForSendingDtoToJSON,
} from '../models/index';

export interface SendEmailRequest {
    emailForSendingDto: EmailForSendingDto;
}

/**
 * 
 */
export class EmailControllerApi extends runtime.BaseAPI {

    /**
     * Send email directly without usage of basic Notification service logic
     * Send email
     */
    async sendEmailRaw(requestParameters: SendEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['emailForSendingDto'] == null) {
            throw new runtime.RequiredError(
                'emailForSendingDto',
                'Required parameter "emailForSendingDto" was null or undefined when calling sendEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/notification/email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailForSendingDtoToJSON(requestParameters['emailForSendingDto']),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Send email directly without usage of basic Notification service logic
     * Send email
     */
    async sendEmail(requestParameters: SendEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.sendEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
